<template>
    <div>
        <v-card color="">
            <v-toolbar flat color="primary" dark height="40" >
                <v-toolbar-title>Item Image Process</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn color="accent" @click="loadImagesToProcess">Reload</v-btn>
                <v-btn @click="GetAllImages">Get All Images</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-card color="grey lighten-1">
                    <v-card-text >
                        <blockquote>
                            <div class="title">Image Process Instruction</div>
                            <div>
                                <b>Step 1: </b>Name the new item images with following naming convention: 
                                [HM Item Num]_[Descript].[image extension(jpg, png)]. 
                                For example, following is valid name: UCC-101_ChannelCheck_Main.jpg
                            </div>
                            <div><b>Step 2: </b>Please Copy New Images to Web Server (hmwebapp01) folder: ???</div>
                            <div><b>Step 3: </b>Then use the following section below to process images:</div>
                        </blockquote>
                    </v-card-text>
                </v-card>
            </v-card-text>
            <v-card-text >
                <v-card>
                    <v-toolbar flat color="error" dark height="40" >
                        <v-toolbar-title>Invalid Images - Count: {{imagesToProcessRpt.imagesInvalid.length}}</v-toolbar-title>
                    </v-toolbar>

                    <v-container grid-list-sm fluid>
                        <v-flex error--text>
                            <div class="subheading ">Following image file name does not contain a valid healthmark item number, please fix it.</div>
                        </v-flex>
                        <v-layout row wrap>
                            <v-flex
                            v-for="img in imagesToProcessRpt.imagesInvalid" 
                            :key="img.originalName"
                            xs4
                            d-flex
                            >
                            <v-card flat tile >
                                <v-card-text >
                                    <v-layout row wrap>
                                        <v-flex xs12 >
                                                <v-img
                                                    :src="`${img.path}`"
                                                    height="150"
                                                    width="200"
                                                    aspect-ratio="1"
                                                    class="grey lighten-2"
                                                >
                                                </v-img>

                                        </v-flex>
                                        <v-flex xs12>
                                                <v-text-field 
                                                    v-model="img.name"
                                                    label="File Name"
                                                    hint="Please Fix Name"
                                                    ></v-text-field>
                                        </v-flex>
                                    </v-layout>

                                </v-card-text>
                                
                                <v-card-actions>
                                        <v-btn small color="primary" @click="onChangeFileName(img)">Update</v-btn>
                                        <v-btn small color="warning" @click="onDeleteFile(img)">Delete</v-btn>

                                </v-card-actions>
                            </v-card>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card>
            </v-card-text>
            <v-card-text >
                <v-card>
                    <v-toolbar flat color="success" dark height="40" >
                        <v-toolbar-title>Valid Images - Count: {{imagesToProcessRpt.imagesValid.length}}</v-toolbar-title>
                    </v-toolbar>

                    <v-container grid-list-sm fluid>
                        <v-flex >
                            <div class="subheading ">Please review images below, if there is no issue, please click "Upload Image To webquote" button below</div>
                            <div class="text-xs-center">
                                <v-spacer></v-spacer>
                                <v-btn color="primary" large @click.prevent="onProcessImages">Upload Image To webquote</v-btn>
                                <v-spacer></v-spacer>
                            </div>
                        </v-flex>
                        <v-layout row wrap>
                            <v-flex
                            v-for="img in imagesToProcessRpt.imagesValid" 
                            :key="img.originalName"
                            xs4
                            d-flex
                            >
                            <v-card flat tile >
                                <v-card-text>
                                    <v-layout row wrap>
                                        <v-flex xs12 >
                                                <v-img
                                                    :src="`${img.path}`"
                                                    height="150"
                                                    width="200"
                                                    aspect-ratio="1"
                                                    class="grey lighten-2"
                                                >
                                                </v-img>

                                        </v-flex>
                                        <v-flex xs12>
                                                <v-text-field 
                                                    v-model="img.name"
                                                    label="File Name"
                                                    ></v-text-field>
                                        </v-flex>
                                    </v-layout>

                                </v-card-text>
                                
                                <v-card-actions>
                                        <v-btn small color="primary" @click.prevent="onChangeFileName(img)">Update</v-btn>
                                        <v-btn small color="warning" @click.prevent="onDeleteFile(img)">Delete</v-btn>

                                </v-card-actions>
                            </v-card>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card>
            </v-card-text>

        </v-card>
        <!-- {{imagesToProcessRpt}} -->
    </div>
</template>
<script>
import { mapActions } from 'vuex'
import axios from 'axios'

export default {
    data () {
        return {
            cantoSecret: {
                app_id: "5f71e92eaf784ee6b45c889871de4b08",
                app_secret: "e24d9e35ee554beb8ff37c07cc64ced72085616267ba4c5d81916c7a6cb057af",
            },
            cantoOptions: {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    "Access-Control-Allow-Origin": "*",
                }
            },
            imagesToProcessRpt: {
                imagesValid: [],
                imagesInvalid: [],
            }
        }
    },
    methods: {
        async cantoAuth() {
            let urlAuth = "https://oauth.canto.com/oauth/api/oauth2/token"
            let resp = await axios.post(urlAuth, this.cantoSecret, this.cantoOptions)
            console.log(resp)
        },
        async GetAllImages() {
            // this.cantoAuth()
            // let url = 'https://healthmark.canto.com/api/v1/album/MF4B9'
            // let data = await axios.get(url)
            let url = 'https://healthmark.canto.com/api/v1'
            let data = await axios.get(url)

        },
        ...mapActions('adminItemImages', [
            'getImagesWaitingForProcess',
            'uploadImagesToCloud',
            'fileOperation'
        ]),
        async loadImagesToProcess() {
            this.imagesToProcessRpt = await this.getImagesWaitingForProcess()
        },
        async onChangeFileName(img) {
            const payload = {
                fileName: img.originalName,
                newFileName: img.name,
                action: 'rename'
            }
            await this.fileOperation(payload)
            alert('file renamed')
            this.loadImagesToProcess()
        },
        async onDeleteFile(img) {
            const payload = {
                fileName: img.originalName,
                action: 'delete'
            }
            await this.fileOperation(payload)
            alert('file deleted')
            this.loadImagesToProcess()
        },
        async onProcessImages(img) {
            var result = await this.uploadImagesToCloud()
            await this.loadImagesToProcess()
            // this.$emit('onImagesProcessed')
        }
    },
    created() {
        this.loadImagesToProcess()
    }
    
}
</script>

